<template>
    <div class="journey-header" :class="{ 'journey-header__active': isActive }">
        <div class="journey-header__locations">
            <div class="journey-header__start-point">
                <div class="journey-header__time">{{ formatDate(startPoint.utc, 'HH:mm') }}</div>
                <div class="journey-header__address">{{ startPoint.address.label || 'Unknown' }}</div>
            </div>
            <div class="journey-header__arrow">
                <icon icon="arrow-circle-right-solid"></icon>
            </div>
            <div class="journey-header__end-point">
                <div class="journey-header__time">{{ formatDate(endPoint.utc, 'HH:mm') }}</div>
                <div class="journey-header__address">{{ endPoint.address.label || 'Unknown' }}</div>
            </div>
        </div>
        <div class="journey-header__details">
            <div v-if="!isCurrentJourney" class="journey-header__distance">{{ distance }}</div>
            <div v-else class="journey-header__live"> <span> Live </span> </div>
            <div class="journey-header__duration">{{ duration }}</div>
        </div>
    </div>
</template>

<script>
import JourneyPoint from '@/models/JourneyPoint'
import moment from 'moment'
import Icon from "@/components/atoms/Icon";
import {mapGetters} from "vuex";

export default {
    name: 'JourneyHeader',
    components: {Icon},
    props: {
        startPoint: {
            type: JourneyPoint,
            required: false
        },
        endPoint: {
            type: JourneyPoint,
            required: true
        },
        distance: {
            type: String,
            required: true,
        },
        duration: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
            required: false,
        },
        isCurrentJourney: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        ...mapGetters({
            selectedJourney: 'trackingModule/getSelectedJourney'
        }),
    },
    methods: {
        formatDate (date, format) {
            return moment(date).format(format)
        },
        isLive () {
            return null == this.endPoint.utc
        }
    }
}
</script>

<style scoped lang="scss">
.journey-header {
    font-size: 12px;
    border: 1px solid $inactive;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

    &:hover,
    &__active {
        background: $primary;
        color: $white;
        .journey-header__live {
            color: #eccc00;
            border-color: #eccc00;
            &::before {
                background-color: #eccc00;
            }
        }
    }

    &__locations {
        display: flex;
    }

    &__start-point {
        padding: 0 5px;
        text-align: right;
        width: calc(50% - (18px / 2));
    }

    &__end-point {
        padding: 0 5px;
        text-align: left;
        width: calc(50% - (18px / 2));
    }

    &__time {
        font-weight: bold;
    }

    &__arrow {
        align-self: center;
        display: flex;
        width: 18px;
        flex-grow: 0;
        flex-shrink: 0;
    }

    &__details {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px 0px;
    }

    &__distance {
    }

    &__duration {
        &::before {
            content: '|';
            padding: 0 5px;
            font-size: 12px;
        }
    }
    &__live {
        display: flex;
        width: 58px;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: .5px;
        color: #13c513;
        border: 2px solid #13c513;
        border-radius: 10px;

        &::before {
            width: 7px;
            height: 7px;
            display: inline-block;
            content: '';
            background-color: #13c513;
            border-radius: 5px;
            margin-left: 8px;
            margin-right: 8px;
            animation: blink 1.3s steps(10, start) infinite;
        }

        span {
            text-transform: uppercase;
        }
    }
}

@keyframes blink {
    50% {
        opacity: 0.0;
    }
}
@-webkit-keyframes blink {
    50% {
        opacity: 0.0;
    }
}
</style>
